export enum AuthType {
  Cred = 'CredentialingAuthentication'
}
